import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { loading } from "state_management";
import { ErrorBoundary, Message } from "components";
import { createRoot } from 'react-dom/client';

import store from "./store";

import App from "./App";
import "./index.scss";
import "./i18n";

// Disable console logging in production, this was a given requirement!
if (process.env.REACT_APP_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}

// Expose store globally in dev for console debugging
if (process.env.REACT_APP_ENV !== "production") {
  window.store = store;
}

console.log("running...");

if (
  store.getState().auth &&
  store.getState().auth.isLoggedIn &&
  store.getState().auth.role !== "admin" &&
  store.getState().auth.role !== "customer_admin"
) {
  store.dispatch(loading.fetchAll(window.location.pathname));
}

// Define routes using createBrowserRouter
const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
  },
]);

// Start the main rendering.
// Up until this point is just "normal" JS code, but after this we enter the
// React-SPA-"framework" rendering!

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Message />
      <RouterProvider router={router} />
    </ErrorBoundary>
  </Provider>
);
